import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from './api/client';
import './JobDetails.css';

const JobDetails = () => {
    const { id: jobId } = useParams();
    const [job, setJob] = useState(null);
    const [appliedJobs, setAppliedJobs] = useState([]);
    const [userRole, setUserRole] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchJobDetails = async () => {
            try {
                const data = await api.get(`/api/job/postjobs/${jobId}`);
                setJob(data);
            } catch (error) {
                console.error("Error fetching job details:", error);
            } finally {
                setIsLoading(false);
            }
        };

        const fetchAppliedJobs = async () => {
            try {
                if (!localStorage.getItem('token')) return;
                const data = await api.get(`/api/job/applied-jobs/me`);
                setAppliedJobs((data || []).map((j) => j._id));
            } catch (error) {
                console.error("Error fetching applied jobs:", error);
            }
        };

        fetchAppliedJobs();
        fetchJobDetails();
        setUserRole(localStorage.getItem('role'));
    }, [jobId]);

    const handleApply = () => {
        if (userRole !== 'candidate') {
            alert('Only candidates can apply. Please sign in as a candidate.');
            return;
        }
        if (!job.formElements) {
            alert('No application form is configured for this opportunity.');
            return;
        }
        navigate('/apply', { state: { formElements: job.formElements, jobId } });
    };

    if (isLoading) {
        return (
            <div className="jd-page">
                <div className="jd-empty">Loading opportunity…</div>
            </div>
        );
    }
    if (!job) {
        return (
            <div className="jd-page">
                <div className="jd-empty">
                    <p>This opportunity could not be found.</p>
                    <button className="sw-btn sw-btn-ghost sw-btn-sm" onClick={() => navigate('/job-listings')}>
                        ← Back to opportunities
                    </button>
                </div>
            </div>
        );
    }

    const title = job.fields?.[0]?.value || 'Untitled role';
    const applied = appliedJobs.includes(job._id);

    return (
        <div className="jd-page">
            <div className="jd-back">
                <button className="sw-btn sw-btn-ghost sw-btn-sm" onClick={() => navigate('/job-listings')}>
                    ← Back to opportunities
                </button>
            </div>

            <header className="jd-head">
                <h1>{title}</h1>
                <div className="jd-tags">
                    <span className="sw-tag sw-tag-success">Active</span>
                    {job.createdAt && (
                        <span className="sw-text-muted" style={{ fontSize: 13 }}>
                            Posted {new Date(job.createdAt).toLocaleDateString()}
                        </span>
                    )}
                </div>
            </header>

            <div className="jd-grid">
                <section className="jd-body sw-card">
                    <h2>Details</h2>
                    <dl className="jd-fields">
                        {job.fields.slice(1).map((field, idx) => (
                            <React.Fragment key={field._id || idx}>
                                <dt>{field.label}</dt>
                                <dd>{field.value || '—'}</dd>
                            </React.Fragment>
                        ))}
                    </dl>
                </section>

                <aside className="jd-side sw-card">
                    <h3>Apply for this role</h3>
                    {userRole === 'candidate' ? (
                        applied ? (
                            <>
                                <div className="jd-applied">
                                    ✓ You have already applied to this opportunity.
                                </div>
                                <button
                                    className="sw-btn sw-btn-ghost sw-btn-sm"
                                    onClick={() => navigate('/candidate-dashboard')}
                                >
                                    View my applications →
                                </button>
                            </>
                        ) : (
                            <>
                                <p className="sw-text-muted" style={{ fontSize: 14 }}>
                                    You will fill in the application form designed by the poster.
                                </p>
                                <button
                                    className="sw-btn sw-btn-saffron sw-btn-lg sw-btn-block"
                                    onClick={handleApply}
                                    style={{ width: '100%' }}
                                >
                                    Apply now
                                </button>
                            </>
                        )
                    ) : userRole === 'admin' ? (
                        <p className="sw-text-muted" style={{ fontSize: 14 }}>
                            Admins cannot apply. Sign in with a candidate account.
                        </p>
                    ) : (
                        <>
                            <p className="sw-text-muted" style={{ fontSize: 14 }}>
                                Please sign in as a candidate to apply.
                            </p>
                            <div style={{ display: 'flex', gap: 8 }}>
                                <button className="sw-btn sw-btn-saffron sw-btn-sm" onClick={() => navigate('/signin')}>
                                    Sign in
                                </button>
                                <button className="sw-btn sw-btn-ghost sw-btn-sm" onClick={() => navigate('/signup')}>
                                    Register
                                </button>
                            </div>
                        </>
                    )}
                </aside>
            </div>
        </div>
    );
};

export default JobDetails;
